module.exports = __webpack_public_path__ + "media/images/logo-sm-feb04ad34cc4b5e9c52921993181d8a3.png";